import { render, staticRenderFns } from "./HeaderDialog.vue?vue&type=template&id=7f2b89e8"
import script from "./HeaderDialog.vue?vue&type=script&lang=js"
export * from "./HeaderDialog.vue?vue&type=script&lang=js"
import style0 from "./HeaderDialog.vue?vue&type=style&index=0&id=7f2b89e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports